import axios from 'axios';
import download from 'downloadjs';
import { baseURL, myEpikBaseURL, unifiedBaseURL } from './api';

const url = require('url');


const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class BoxService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    const urlObj = url.parse(document.location.href, true);
    // const dev = urlObj.href.indexOf('my.epik.io') !== -1;
    const route = window.location.pathname.split('/');
    // if (!dev) {
    //   return this.baseURL || BoxService.resourcePath || BoxService.baseURL;
    // }
    if (global.myEpik === 'Yes' && route.length === 3) {
      return myEpikBaseURL;
    }
    if (global.myEpik === 'No' && route.length === 3) {
      return unifiedBaseURL();
    }
    global.myEpik = 'Yes';
    return this.baseURL || BoxService.resourcePath || BoxService.baseURL;
  };

  async generateReport({
    cid,
    lid,
    type,
    summary,
    fromDate,
    toDate,
    selectedReport,
    symbol,
    lineTypes,
    alarmProtocolValue,
    setUptime,
    integration,
    box,
    selectedNumber,
    activeInterface
  }) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const REPORT_CONFIG_MAP = new Map([
      ["PAD", { portActivationDetails: { type, includeSummary: summary, from: fromDate, to: toDate }}],
      ["DID", { didAssignmentReport: { type, location: lid }}],
      ["911", { e911EnabledReport: { type, location: lid }}],
      ["TDID", { tempDidReport: { type, location: lid }}],
      ["LT", { 'lineTypeReport': { type, location: lid, from: fromDate, to: toDate }}],
      ["BOL", { 'offlineBoxReport': { type, location: lid, from: fromDate, to: toDate }}],
      ["BAD", { 'bad-ports-report': { type }}],
      ["PAR", { 'portal-assets': { type }}],
      ["DAR", { 'data-center-report': { type }}],
      ["EDI", { 'device-integration-report': { type, integrationType: integration }}],
      ["NSR", { 'network-summary-report': { type }}],
      ["AFR", { 'ata-firmware-report': { type }}],
      ["UTR", { 'uptime-report': { type, from: fromDate, to: toDate, setUptime: JSON.stringify(setUptime) }}],
      ["SIM", { 'sims-report': { type }}],
      ["INT", { 'interface-report': { type }}],
      ["E911", { e11SubscribedNumbers: { type, location: lid }}],
      ["OOBM_TTY", { oobmUserNameList: { type }}],
      ["PRI_BOX", { priBox: { type }}],
      ["BLR", { 'battery-life-report': { type }}],
      ["PORT_CDR", { 'port-cdr-report': { type, serialNumber: box ? box.serialNumber : null, number: selectedNumber ? selectedNumber.number : null, portNumber: selectedNumber ? selectedNumber.portNumber : null }}],
      ["COMP_CDR", { 'company-cdr-report': { type }}],
      ["ACTIVE_INTERFACE", { activeInterface: { type, interface: activeInterface } }],     ]);
  
    const config = REPORT_CONFIG_MAP.get(symbol) || { 'apr-report': { type, apr: alarmProtocolValue }};
    const [name, params] = Object.entries(config)[0];
  
    const API_URL = `${process.env.REACT_APP_REPORT_URL}/api/reports/${name}`;
  
    const body = symbol === 'LT' ? { cid, lineTypes } : symbol === 'PORT_CDR' ? { cid, serialNumber: box ? box.serialNumber : null, number: selectedNumber ? selectedNumber.number : null, portNumber: selectedNumber ? selectedNumber.portNumber : null } : { cid };
  
    const { data } = await axios.post(API_URL, body, {
      params,
      headers,
      responseType: 'blob',
    });

    const reportsWithDate = ['PAD', 'BOL', 'LT'];
    const includeDatesInFilename = reportsWithDate.includes(symbol) ? ` - from ${fromDate} to ${toDate}` : '';
    const fileName = `${selectedReport}${includeDatesInFilename}.${type}`;

    download(data, fileName);
    return data;
  }

  // GET all company group lists
  async getCompanyGroups(pagination, format) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companyGroups?paginateResult=${pagination}&formatResponse=${format}`,
      { headers, timeout: 1000 * 60 * 10 },
    );
    return data;
  }

  // GET all the companies alocated to specific company group
  async getGroupsFilterCompanies(gid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/companyGroups/${gid}`, {
      headers,
    });
    return data;
  }

  async generatePortOrderReport() {
    const API_URL = `${myEpikBaseURL}${apiVersion}/reports/port-orders?type=csv`;
    const data = await axios.post(
      API_URL,
      {},
      {
        headers: { Authorization: `Bearer ${this.api.token}` },
        responseType: 'blob',
      },
    );
    const file = new Blob([data.data], { type: 'text/csv' });
    const fileURL = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = fileURL;
    const fileName = `Port Orders List.csv`;
    a.download = fileName;
    a.click();
  }

  async generateCallsReport({
    cid,
    type,
    fromDate,
    toDate,
    activeCallsTab,
    filter,
    paginateOptions,
  }) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const params = { type, company: cid, activeCallsTab, search: JSON.stringify(filter), paginateOptions: JSON.stringify(paginateOptions), from: fromDate, to: toDate };
    const API_URL = `${process.env.REACT_APP_REPORT_URL}/api/reports/calls-report`;
    const body = { cid };

    const { data } = await axios.post(API_URL, body, {
      params,
      headers,
      responseType: 'blob',
    });

    const includeDatesInFilename = ` - from ${fromDate} to ${toDate}`;
    const fileName = `Calls${includeDatesInFilename}.${type}`;

    download(data, fileName);
    return data;
  }
  async generateUsersReport({cid, company_id, role, companyType,userType}) {
     const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    
    const queryString = new URLSearchParams({
      disablePaginate: 'yes',
      getDeleted: 'false',
      role: role || '', 
      companyType: companyType || '',
      userType:userType || ''
    }).toString();
    
    const API_URL = `${process.env.REACT_APP_REPORT_URL}/api/reports/users-report?${queryString}`;
    
    const body = { cid, company_id };
    const { data } = await axios.post(API_URL, body, {
      headers,
      responseType: 'blob',
    });
    
    const fileName = `Users`;
    download(data, fileName);
    return data;
  }
}

export default BoxService;
